// Envía un evento a Google Analytics 4 de forma segura.
// Si gtag no está disponible (bloqueadores, sin consentimiento, etc.) no hace nada.
export const trackEvent = (name, params = {}) => {
    try {
        if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
            window.gtag('event', name, params);
        }
    } catch (e) {
        /* noop */
    }
};

export default trackEvent;
